export const API_PREFIX = "/api";

export const API = {
  health: `${API_PREFIX}/health`,
  companies: `${API_PREFIX}/companies`,
  companyFolders: `${API_PREFIX}/companies/:companyId/folders`,
  companyFolder: `${API_PREFIX}/companies/:companyId/folders/:folderId`,
  companyFolderMove: `${API_PREFIX}/companies/:companyId/folders/:folderId/move`,
  companyFolderItemMove: `${API_PREFIX}/companies/:companyId/folders/items/move`,
  agents: `${API_PREFIX}/agents`,
  projects: `${API_PREFIX}/projects`,
  environments: `${API_PREFIX}/environments`,
  environmentDeleteBlastRadius: `${API_PREFIX}/environments/:id/delete-blast-radius`,
  environmentCustomImageTemplate: `${API_PREFIX}/environments/:environmentId/custom-image-template`,
  environmentCustomImageTemplateDisable: `${API_PREFIX}/environments/:environmentId/custom-image-template`,
  environmentCustomImageTemplateRollback: `${API_PREFIX}/environments/:environmentId/custom-image-template/rollback`,
  environmentCustomImageSetupSessions: `${API_PREFIX}/environments/:environmentId/custom-image-setup-sessions`,
  environmentCustomImageSetupSession: `${API_PREFIX}/environment-custom-image-setup-sessions/:sessionId`,
  environmentCustomImageSetupSessionTerminalToken: `${API_PREFIX}/environment-custom-image-setup-sessions/:sessionId/terminal-session-token`,
  environmentCustomImageSetupSessionTerminalWs: `${API_PREFIX}/environment-custom-image-setup-sessions/:sessionId/terminal/ws`,
  environmentCustomImageSetupSessionFinish: `${API_PREFIX}/environment-custom-image-setup-sessions/:sessionId/finish`,
  environmentCustomImageSetupSessionCancel: `${API_PREFIX}/environment-custom-image-setup-sessions/:sessionId/cancel`,
  issues: `${API_PREFIX}/issues`,
  stalledReviewDecision: `${API_PREFIX}/issues/:issueId/stalled-review-decision`,
  issueWatchdog: `${API_PREFIX}/issues/:issueId/watchdog`,
  issueTreeControl: `${API_PREFIX}/issues/:issueId/tree-control`,
  issueTreeHolds: `${API_PREFIX}/issues/:issueId/tree-holds`,
  summarySlot: `${API_PREFIX}/companies/:companyId/summary-slots/:scopeKind/:slotKey`,
  summarySlotRevisions: `${API_PREFIX}/companies/:companyId/summary-slots/:scopeKind/:slotKey/revisions`,
  summarySlotGenerate: `${API_PREFIX}/companies/:companyId/summary-slots/:scopeKind/:slotKey/generate`,
  goals: `${API_PREFIX}/goals`,
  approvals: `${API_PREFIX}/approvals`,
  secrets: `${API_PREFIX}/secrets`,
  tools: `${API_PREFIX}/companies/:companyId/tools`,
  toolExamples: `${API_PREFIX}/companies/:companyId/tools/examples`,
  toolApplications: `${API_PREFIX}/companies/:companyId/tools/applications`,
  toolConnections: `${API_PREFIX}/companies/:companyId/tools/connections`,
  toolCatalog: `${API_PREFIX}/companies/:companyId/tools/catalog`,
  toolProfiles: `${API_PREFIX}/companies/:companyId/tools/profiles`,
  toolPolicies: `${API_PREFIX}/companies/:companyId/tools/policies`,
  toolAudit: `${API_PREFIX}/companies/:companyId/tools/audit`,
  toolRuntimeSlots: `${API_PREFIX}/companies/:companyId/tools/runtime-slots`,
  toolRuntimeSlotStop: `${API_PREFIX}/companies/:companyId/tools/runtime-slots/:id/stop`,
  toolRuntimeSlotRestart: `${API_PREFIX}/companies/:companyId/tools/runtime-slots/:id/restart`,
  toolRuntimeHealth: `${API_PREFIX}/companies/:companyId/tools/runtime-health`,
  toolGateway: `${API_PREFIX}/tool-gateway`,
  smokeLab: `${API_PREFIX}/companies/:companyId/smoke-lab`,
  smokeLabServices: `${API_PREFIX}/companies/:companyId/smoke-lab/services`,
  smokeLabInstallFixtures: `${API_PREFIX}/companies/:companyId/smoke-lab/install-fixtures`,
  smokeLabRuns: `${API_PREFIX}/companies/:companyId/smoke-lab/runs`,
  smokeLabRunSteps: `${API_PREFIX}/companies/:companyId/smoke-lab/runs/:runId/steps`,
  userSecretDefinitions: `${API_PREFIX}/companies/:companyId/user-secret-definitions`,
  userSecretDefinition: `${API_PREFIX}/companies/:companyId/user-secret-definitions/:definitionId`,
  userSecretDefinitionCoverage: `${API_PREFIX}/companies/:companyId/user-secret-definitions/:definitionId/coverage`,
  myUserSecrets: `${API_PREFIX}/companies/:companyId/me/user-secrets`,
  myUserSecret: `${API_PREFIX}/companies/:companyId/me/user-secrets/:secretId`,
  secretProviderConfigs: `${API_PREFIX}/secret-provider-configs`,
  secretProviderConfigDiscoveryPreview: `${API_PREFIX}/companies/:companyId/secret-provider-configs/discovery/preview`,
  costs: `${API_PREFIX}/costs`,
  activity: `${API_PREFIX}/activity`,
  dashboard: `${API_PREFIX}/dashboard`,
  sidebarBadges: `${API_PREFIX}/sidebar-badges`,
  sidebarPreferences: `${API_PREFIX}/sidebar-preferences`,
  resourceMemberships: `${API_PREFIX}/resource-memberships`,
  invites: `${API_PREFIX}/invites`,
  joinRequests: `${API_PREFIX}/join-requests`,
  members: `${API_PREFIX}/members`,
  admin: `${API_PREFIX}/admin`,
} as const;
